/**
 * Strip the /pl crawl prefix so the SPA matches existing routes
 * and can pin Polish when a crawler or a search result opens that URL.
 */

export type CrawlLang = 'en' | 'pl';

export function parseCrawlLocale(pathname: string): { lang: CrawlLang; path: string } {
  if (pathname === '/pl' || pathname === '/pl/') {
    return { lang: 'pl', path: '/' };
  }
  if (pathname.startsWith('/pl/')) {
    const rest = pathname.slice(3) || '/';
    return { lang: 'pl', path: rest.startsWith('/') ? rest : `/${rest}` };
  }
  return { lang: 'en', path: pathname || '/' };
}

/** Marketing routes that have a Polish prerender shell. Blog posts and legal pages do not. */
const LOCALIZED_EXACT = new Set([
  '/',
  '/start',
  '/agentic',
  '/pricing',
  '/how-it-works',
  '/why-us',
  '/roadmap',
  '/blog',
  '/faq',
  '/solutions',
  '/contact',
]);

export function hasPolishCrawlShell(logicalPath: string): boolean {
  if (!logicalPath || logicalPath.startsWith('/blog/')) return false;
  if (logicalPath === '/privacy' || logicalPath === '/cookies') return false;
  if (logicalPath === '/solutions' || logicalPath.startsWith('/solutions/')) return true;
  return LOCALIZED_EXACT.has(logicalPath);
}
